import { CSSProperties } from "react";
import Color from "../../../../../../../models/constants/Color";

export default class PaginatedDialogFooterViewStyle {

    footer : CSSProperties = {
        display : "flex",
        alignItems : "center",
        justifyContent : 'space-between',
        padding : '20px 0 0 0'
    }

    bulletPoint : CSSProperties = {
        height : 8, 
        width : 8,
        margin : 4,
        borderRadius : '50%',
        border : `1px solid ${Color.Primary}`,
    }

    bullets : CSSProperties = {
        display : "flex"
    }
}